// Ids match sales.price_derivation_operation, seeded alongside the price_rule_amount derivation
// columns. `set` is deliberately not a member -- it ignores the
// basis entirely (see computeAdjustedAmount), so it's a literal write, not a persisted formula.
export var PriceDerivationOperation;
(function (PriceDerivationOperation) {
    PriceDerivationOperation[PriceDerivationOperation["INCREASE_PERCENT"] = 1] = "INCREASE_PERCENT";
    PriceDerivationOperation[PriceDerivationOperation["DECREASE_PERCENT"] = 2] = "DECREASE_PERCENT";
    PriceDerivationOperation[PriceDerivationOperation["INCREASE_FIXED"] = 3] = "INCREASE_FIXED";
    PriceDerivationOperation[PriceDerivationOperation["DECREASE_FIXED"] = 4] = "DECREASE_FIXED";
})(PriceDerivationOperation || (PriceDerivationOperation = {}));
//# sourceMappingURL=price-derivation-operation.js.map